import { MISCELLANEOUS_RESOURCES, PAGE_NAMES } from 'constant';
import confiscationAndRefund from 'assets/settings/role.png';
import messageCenterImg from 'assets/miscellaneous/messageCenter.png';
import invoiceGenerationImg from 'assets/miscellaneous/invoiceGeneration.png';
import refundRequestImg from 'assets/miscellaneous/refundRequest.png';
import suspiciousTransactionsImg from 'assets/miscellaneous/suspiciousTransactions.jpg';
import creditKindRewardImg from 'assets/miscellaneous/creditKindReward.png';
import legalDetailsImg from 'assets/miscellaneous/legalDetails.png';
import dpdpaDataAccessImg from 'assets/miscellaneous/dpdpaDataAccess.png';

import ConfiscationAndRefund from './confiscationAndRefund';
import MessageCenter from './messageCenter';
import InvoiceGeneration from './invoiceGeneration';
import RefundRequest from './refundRequest';
import KindRewards from './kindReward';
import LegalDetails from './legalDetails';
import SuspiciousTransactions from './suspiciousTransactions';
import DpdpaDataAccess from './dpdpaDataAccess';

export const URL = {
	[MISCELLANEOUS_RESOURCES.confiscationAndRefund]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.confiscationAndRefund}`,
	[MISCELLANEOUS_RESOURCES.messageCenter]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.messageCenter}`,
	[MISCELLANEOUS_RESOURCES.invoiceGeneration]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.invoiceGeneration}`,
	[MISCELLANEOUS_RESOURCES.refundRequest]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.refundRequest}`,
	[MISCELLANEOUS_RESOURCES.kindRewards]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.kindRewards}`,
	[MISCELLANEOUS_RESOURCES.legalDetails]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.legalDetails}`,
	[MISCELLANEOUS_RESOURCES.suspiciousTransactions]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.suspiciousTransactions}`,
	[MISCELLANEOUS_RESOURCES.dpdpaDataAccess]: `/${PAGE_NAMES.miscellaneous}/${MISCELLANEOUS_RESOURCES.dpdpaDataAccess}`
};

export const LABEL = {
	[MISCELLANEOUS_RESOURCES.confiscationAndRefund]: 'Confiscation and Refund',
	[MISCELLANEOUS_RESOURCES.messageCenter]: 'Message Center',
	[MISCELLANEOUS_RESOURCES.invoiceGeneration]: 'Invoice Generation',
	[MISCELLANEOUS_RESOURCES.refundRequest]: 'Refund Request',
	[MISCELLANEOUS_RESOURCES.kindRewards]: 'Kind Rewards',
	[MISCELLANEOUS_RESOURCES.legalDetails]: 'User Lifetime Details',
	[MISCELLANEOUS_RESOURCES.suspiciousTransactions]: 'Suspicious Transactions',
	[MISCELLANEOUS_RESOURCES.dpdpaDataAccess]: 'DPDPA Data Access'
};

export const COMPONENT = {
	[MISCELLANEOUS_RESOURCES.confiscationAndRefund]: ConfiscationAndRefund,
	[MISCELLANEOUS_RESOURCES.messageCenter]: MessageCenter,
	[MISCELLANEOUS_RESOURCES.invoiceGeneration]: InvoiceGeneration,
	[MISCELLANEOUS_RESOURCES.refundRequest]: RefundRequest,
	[MISCELLANEOUS_RESOURCES.kindRewards]: KindRewards,
	[MISCELLANEOUS_RESOURCES.legalDetails]: LegalDetails,
	[MISCELLANEOUS_RESOURCES.suspiciousTransactions]: SuspiciousTransactions,
	[MISCELLANEOUS_RESOURCES.dpdpaDataAccess]: DpdpaDataAccess
};

export const IMAGE_SOURCE = {
	[MISCELLANEOUS_RESOURCES.confiscationAndRefund]: confiscationAndRefund,
	[MISCELLANEOUS_RESOURCES.messageCenter]: messageCenterImg,
	[MISCELLANEOUS_RESOURCES.invoiceGeneration]: invoiceGenerationImg,
	[MISCELLANEOUS_RESOURCES.refundRequest]: refundRequestImg,
	[MISCELLANEOUS_RESOURCES.kindRewards]: creditKindRewardImg,
	[MISCELLANEOUS_RESOURCES.legalDetails]: legalDetailsImg,
	[MISCELLANEOUS_RESOURCES.suspiciousTransactions]: suspiciousTransactionsImg,
	[MISCELLANEOUS_RESOURCES.dpdpaDataAccess]: dpdpaDataAccessImg
};
